export default class MemberSettings {
    managedByFederation = false;
    membershipNumberPrefix = '';
    membershipNumberSuffix = '';
    membershipNumberRangeStart = 1;
    membershipNumberLeadingZeros = false;
    membershipNumberDigits = 6;
    membershipNumberRecycling = false;
    counterBasedOnPreAndSuffix = false;

    static fromData(data: Record<string, unknown>): MemberSettings | undefined {
        if (!data) {
            return;
        }

        const memberSettings = new MemberSettings();
        memberSettings.managedByFederation = (data.managedByFederation as boolean) || false;
        memberSettings.membershipNumberPrefix = data.membershipNumberPrefix as string;
        memberSettings.membershipNumberSuffix = data.membershipNumberSuffix as string;
        memberSettings.membershipNumberRangeStart = data.membershipNumberRangeStart as number;
        memberSettings.membershipNumberLeadingZeros = data.membershipNumberLeadingZeros as boolean;
        memberSettings.membershipNumberDigits = (data.membershipNumberDigits as number) ?? 6;
        memberSettings.membershipNumberRecycling = data.membershipNumberRecycling as boolean;
        memberSettings.counterBasedOnPreAndSuffix = data.counterBasedOnPreAndSuffix as boolean;

        return memberSettings;
    }
}
